import clockLogo from "@assets/images/clock.svg";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";

interface AgingCellProps {
  children: string;
}

const useStyles = makeStyles(
  {
    agingAmber: {
      backgroundColor: "#FFBF00"
    },
    agingGreen: {
      backgroundColor: "#6DAB64"
    },
    agingHolder: {
      alignItems: "center",
      borderRadius: "20px",
      color: "white",
      display: "flex",
      justifyContent: "space-evenly",
      padding: "5px 5px",
      width: "120px"
    },
    agingRed: {
      backgroundColor: "#E26139"
    },
    clockLogo: {
      height: "16px"
    }
  },
  { name: "OrderAging" }
);

function AgingCell(props: AgingCellProps) {
  const { children } = props;
  const agingValue = Number(children);
  const classes = useStyles(props);
  let backgroundColor;

  if (agingValue >= 0 && agingValue <= 29) {
    backgroundColor = classes.agingGreen;
  } else if (agingValue >= 30 && agingValue <= 39) {
    backgroundColor = classes.agingAmber;
  } else if (agingValue >= 40) {
    backgroundColor = classes.agingRed;
  }

  function timeConvert(n) {
    const num = n;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);

    return rminutes < 60 && rhours === 0
      ? rminutes + " mins"
      : rhours === 1
      ? rhours + " hour"
      : rhours + " hours";
  }

  return (
    <div className={classNames(backgroundColor, classes.agingHolder)}>
      <img className={classes.clockLogo} src={clockLogo} alt="" />{" "}
      {timeConvert(agingValue)}
    </div>
  );
}

export default AgingCell;
